/**
 * DO NOT MANUAL MODIFY THIS FILE
 *
 * AUTO GENERATED
 */
import { Ref, SVGProps, forwardRef } from 'react';
import classNames from 'classnames';
import { ICON_CLASS } from '../../../utils/constants';
import * as Styled from '../Icon.styles';
const StarHalfSolidBase = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="#404040" width="1em" height="1em" ref={ref} {...props}><path fillRule="evenodd" clipRule="evenodd" d="M6.09 20.065a.5.5 0 0 0 .745.541L12 17.49l5.166 3.117a.5.5 0 0 0 .745-.541l-1.371-5.876 4.564-3.954a.5.5 0 0 0-.285-.876l-6.009-.51-2.35-5.544a.5.5 0 0 0-.92 0L9.19 8.849l-6.01.51a.5.5 0 0 0-.284.876l4.564 3.954-1.37 5.876Zm8.761-3.192-2.779-1.677a.15.15 0 0 1-.072-.128V8.082c0-.163.224-.209.288-.058l1.116 2.632a.15.15 0 0 0 .125.091l3.224.274a.15.15 0 0 1 .086.263l-2.452 2.124a.15.15 0 0 0-.048.148l.736 3.155a.15.15 0 0 1-.224.162Z" /></svg>);
const StarHalfSolid = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(({
  className,
  ...rest
}: SVGProps<SVGSVGElement> & {
  className?: string;
}, ref) => <Styled.Icon className={classNames(ICON_CLASS, className)} as={StarHalfSolidBase} {...rest} ref={ref} />);
export default StarHalfSolid;